// Arrow keys inside a role="radiogroup" of buttons (car size, day chips,
// time slots): move to the next or previous radio and choose it, as a native
// radio group does. Put it on the group's onKeyDown. A radio marked
// data-radio-skip (the "More dates" chip, which opens a calendar) is left
// out of the cycle.
const STEP = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }

// Pure: the index to move to, or -1 to do nothing.
export const nextRadioIndex = (key, index, count) => {
  const step = STEP[key]
  if (!step || index < 0 || count < 1) return -1
  return (index + step + count) % count
}

export const radioGroupKeyDown = event => {
  const group = event.currentTarget
  if (!group || typeof group.querySelectorAll !== 'function') return
  const radios = Array.from(group.querySelectorAll('[role="radio"]:not([data-radio-skip])'))
  const current = event.target && event.target.closest ? event.target.closest('[role="radio"]') : null
  const next = nextRadioIndex(event.key, radios.indexOf(current), radios.length)
  if (next < 0) return
  event.preventDefault()
  radios[next].focus()
  radios[next].click()
}
